import { useCallback } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  ComponentEmptyButton,
  ComponentStartCover,
} from '../shared/component-parts';
import { EditProps } from './interactive-ebook.constants';
import { useContainerDimensions } from '../shared/component-height/component-dimensions.hooks';
import { useBatchComponentUpdateContext } from '../shared/batch-component-update.context';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { ComponentDimensions } from '../shared/component-height/component-dimensions';
import {
  getClosestImageUrl,
  ImageDisplayQuality,
} from 'approot/shared/images/imgix-responsive';

const InteractiveEbookEdit = (props: EditProps) => {
  const { sectionId, properties, id, stimulusResourceProperties } = props;

  const { activeComponent, openDrawer } = useActivityBuilderContext();
  const { updateComponentProperties } = useBatchComponentUpdateContext();

  const { style, setContainerElement, elementDimensions } =
    useContainerDimensions({
      aspectRatio: 16 / 9,
    });

  const handleHeightUpdate = useCallback(
    (width: number, height: number) => {
      const dimensionData = {
        ...properties.dimensionData,
        width,
        height: Math.floor(height),
      };
      updateComponentProperties({
        input: {
          sectionId,
          componentId: id,
          componentData: {
            properties: {
              dimensionData,
            },
          },
        },
        properties: {
          ...properties,
          dimensionData,
        },
        typename: 'ActivitiesInteractiveEbookComponent',
      });
    },
    [id, sectionId, properties, updateComponentProperties]
  );

  return stimulusResourceProperties?.link ? (
    <ComponentDimensions
      id={id}
      showHandle={activeComponent?.id === props.id}
      defaultValue={properties.dimensionData}
      onResizeEnd={handleHeightUpdate}
    >
      <ComponentAbsoluteWrapper ref={setContainerElement}>
        <ComponentStartCover
          backgroundImage={
            stimulusResourceProperties?.xlCoverImageUrls?.length
              ? getClosestImageUrl({
                  imageUrls: stimulusResourceProperties.xlCoverImageUrls,
                  containerSize: elementDimensions?.width
                    ? Math.max(
                        elementDimensions.width,
                        elementDimensions.height
                      )
                    : window.innerWidth,
                  quality: ImageDisplayQuality.High,
                })
              : stimulusResourceProperties?.coverImage?.original
          }
          buttonLabel="Start"
          resourceName={stimulusResourceProperties.resourceName}
          type={props.type}
          style={style}
          data-selector="btn-start"
        />
      </ComponentAbsoluteWrapper>
    </ComponentDimensions>
  ) : (
    <ComponentEmptyButton
      iconId="e-book-interactive"
      buttonText="Add eBook (Interactive)"
      onClick={() => openDrawer({ componentId: props.id })}
    />
  );
};

export default InteractiveEbookEdit;
